export type SubtitleLine = {
  time: string;
  speaker: string;
  cn: string;
  mandarin: string;
  subtitle: string;
};

export const subtitleScene = {
  title: "样例场景 · 清晨的办公室",
  note: "同一段对白在三种版本中的译文差异示意，用于说明各版本的风格取向。",
  lines: [
    {
      time: "00:02:14",
      speaker: "女秘书",
      cn: "早上好，今天的日程我已经整理好了。",
      mandarin: "早上好，今天的安排我都排好啦。",
      subtitle: "早安。今日の予定は整理済みです。→ 早上好，今天的日程已整理完毕。",
    },
    {
      time: "00:02:21",
      speaker: "上司",
      cn: "比我想象中还要周到，谢谢。",
      mandarin: "想得比我还细，谢啦。",
      subtitle: "思った以上に丁寧だ、ありがとう。→ 比预想中更周到，谢谢。",
    },
    {
      time: "00:02:29",
      speaker: "女秘书",
      cn: "这是我应该做的，有需要请随时告诉我。",
      mandarin: "这是我分内的事，有事随时叫我。",
      subtitle: "当然のことをしたまでです。何かあればお声がけください。→ 只是做了分内之事，若有需要请告知。",
    },
    {
      time: "00:02:36",
      speaker: "旁白",
      cn: "她习惯把每一件小事都安排妥当。",
      mandarin: "她总爱把每件小事都打理得妥妥帖帖。",
      subtitle: "彼女は小さなことまで整えておく習慣がある。→ 她有把小事情都先安排好的习惯。",
    },
  ] as SubtitleLine[],
};

export const subtitleVariants = [
  { id: "cn", label: "中文版", desc: "规范书面表达" },
  { id: "mandarin", label: "国语版", desc: "口语化顺读" },
  { id: "subtitle", label: "中文字幕", desc: "逐句对应原文" },
] as const;